<template>
  <div>
    <div class="wo-container">
      <v-row
        align="center"
        style="padding-bottom: 20px !important"
      >
        <v-col
          lg="3"
          md="4"
          sm="6"
          xs="12"
          class="p-0"
          style="padding-left: 20px !important"
        >
          <h3 class="contract--number">
            {{ title }}
          </h3>
        </v-col>
        <v-spacer v-if="!$vuetify.breakpoint.smAndDown" />
        <v-col
          class="p-0"
          lg="2"
          md="4"
          sm="6"
          xs="12"
        >
          <VSelect
            v-model="currentStatus"
            outlined
            :label="$t('analysisRequests.labels.status')"
            :items="labWoStatus"
            :loading="!currentStatus"
            itemText="name"
            itemValue="id"
            dense
            hideDetails
            data-cy="buttonStatusWO"
            @change="onChangeLabWoStatus"
          />
        </v-col>
        <v-col
          cols="auto"
        >
          <ActionButtons :actionButtons="getActionButtons" />
        </v-col>
      </v-row>
      <div class="wo-inner-container">
        <div class="wo-line" />
        <WorkOrderSection
          iconName="info_outline"
          sectionName="Information"
          :showReportSection="true"
          :sectionTitle="$t('forms.labels.information')"
          :displayShowHideSection="false"
        >
          <template #child>
            <v-row>
              <v-col
                cols="12"
                md="4"
              >
                <VTextField
                  :value="labWorkOrder.client.name"
                  :label="$t('forms.labels.clientName')"
                  disabled
                  outlined
                  dense
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <VTextField
                  :value="labWorkOrder.summaryReport.name"
                  :label="$t('forms.labels.reportName')"
                  :disabled="infoSectionDisabled"
                  outlined
                  dense
                  @input="debouncedUpdateWorkOrder"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                md="4"
              >
                <VTextField
                  :value="labWorkOrder.site.name"
                  :label="$t('forms.labels.siteName')"
                  disabled
                  outlined
                  dense
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <VTextField
                  :value="labReport"
                  :label="$t('forms.labels.type')"
                  outlined
                  disabled
                  dense
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                md="4"
              >
                <VTextField
                  :value="labWorkOrder.site.address"
                  :label="$t('forms.labels.siteAddress')"
                  outlined
                  disabled
                  dense
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <VTextField
                  :value="$options.filters.formatDate(labWorkOrder.createdAt, 'L LT')"
                  :label="$t('forms.labels.dateTime')"
                  disabled
                  outlined
                  dense
                  @input="debouncedUpdateWorkOrder"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                md="4"
              >
                <VTextarea
                  v-model="description"
                  :label="$t('forms.labels.description')"
                  :disabled="infoSectionDisabled"
                  dense
                  outlined
                  @change="debouncedSendUpdate('description', $event)"
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <VAutocomplete
                  v-model="assignedTo"
                  :label="$t('forms.labels.assignedTo')"
                  :items="displayedLabMembers"
                  :disabled="infoSectionDisabled"
                  dense
                  outlined
                  @input="update('assignedTo', $event)"
                />
                <VTextField
                  v-model="labWorkOrder.soNumber"
                  :label="$t('forms.labels.soNumber')"
                  :disabled="infoSectionDisabled"
                  outlined
                  dense
                  @change="debouncedSendUpdate('soNumber', $event)"
                />
              </v-col>
            </v-row>
          </template>
        </WorkOrderSection>
        <WorkOrderSection
          iconName="rate_review"
          sectionName="Opening comment"
          :showReportSection="true"
          :sectionTitle="$t('forms.labels.openingComment')"
          :displayShowHideSection="false"
        >
          <template #child>
            <v-row style="padding: 0px 13px 20px 13px">
              <GlobalComment
                position="opening"
                :comment="lastOpeningComment"
                :canUploadImages="false"
                :isLab="true"
                :options="getOptions"
              />
            </v-row>
          </template>
        </WorkOrderSection>
        <WorkOrderSection
          iconName="science"
          sectionName="Analysis Request"
          :showReportSection="true"
          :sectionTitle="$t('analysisRequests.pageName')"
          :displayShowHideSection="false"
          :containerClass="'px-0'"
        >
          <template #child>
            <v-row style="padding: 0px 0px 20px 0px">
              <LabWorkOrderAnalysisRequestsList
                :isSummaryView="false"
                :analysisRequests="analysisRequests"
                @reloadAR="reloadLabRequest"
              />
            </v-row>
          </template>
        </WorkOrderSection>
        <WorkOrderSection
          iconName="rate_review"
          sectionName="Comments & pictures"
          :showReportSection="true"
          :sectionTitle="$t('visitSummary.commentsAndPictures')"
          :displayShowHideSection="false"
        >
          <template #child>
            <v-row style="padding: 0px 13px 20px 13px">
              <GlobalComment
                position="comments"
                :comment="lastCommentAndPicture"
                :isLab="true"
                :options="getOptions"
                @comments="getComments"
              />
            </v-row>
          </template>
        </WorkOrderSection>
        <WorkOrderSection
          iconName="rate_review"
          sectionName="Closing comment"
          :showReportSection="true"
          :sectionTitle="$t('forms.labels.closingComment')"
          :displayShowHideSection="false"
        >
          <template #child>
            <v-row style="padding: 0px 13px 20px 13px">
              <GlobalComment
                position="closing"
                :comment="lastClosingComment"
                :canUploadImages="false"
                :isLab="true"
                :options="getOptions"
              />
            </v-row>
          </template>
        </WorkOrderSection>
        <WorkOrderSection
          iconName="attach_file"
          sectionName="Appendix"
          :showReportSection="true"
          :sectionTitle="$t('forms.labels.appendices')"
          :displayShowHideSection="false"
          isLast
        >
          <template #child>
            <v-row style="padding: 0px 10px">
              <v-col cols="12">
                <VFileDragAndDrop
                  :file="newAppendiceFile"
                  :mimes="['application/pdf']"
                  :disabled="isApproved || isSubmitted || isSent"
                  :loading="uploadFileLoading"
                  :showPdfResizeMsg="true"
                  autoUpload
                  @onChange="onDragAndDropChange"
                />
              </v-col>
            </v-row>
            <v-row style="padding: 0px 30px 10px 30px !important">
              <UploadedBackendFiles
                :backendFiles="files"
                type="appendix"
                :disabled="isApproved || isSubmitted || isSent"
                v-on="$listeners"
                @removeFiles="removeFile"
              />
            </v-row>
          </template>
        </WorkOrderSection>
      </div>
    </div>
    <LoadingWidget
      :show="isDownloadingReport"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import ActionButtons from '@/components/shared/ActionButtons';
import labWorkOrderStatus from '@/constants/labWorkOrderStatus';
import Recommendations from '@/views/laboratory/workOrder/summary/Recommendations';
import SendEmailToUserFormVue from '@/components/forms/SendEmailToUserForm.vue';
import { last, sortBy, debounce } from 'lodash';
import roles from '@/constants/roles';
import WorkOrderSection from '@/views/workOrders/overview/WorkOrderSection';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import GlobalComment from '@/views/laboratory/workOrder/summary/GlobalComment';
import LoadingWidget from '@/components/shared/widgets/LoadingWidget';
import LabWorkOrderAnalysisRequestsList from '@/views/laboratory/workOrder/LabWorkOrderAnalysisRequestsList';
import UploadedBackendFiles from '@/components/shared/UploadedBackendFiles.vue';
import VFileDragAndDrop from '@/components/shared/widgets/forms/VuetifyInputs/VFileDragAndDrop';
import VAutocomplete from '@/components/shared/widgets/forms/VuetifyInputs/VAutocomplete';

export default {
    components: {
        ActionButtons,
        WorkOrderSection,
        VTextField,
        GlobalComment,
        LoadingWidget,
        LabWorkOrderAnalysisRequestsList,
        UploadedBackendFiles,
        VFileDragAndDrop,
        VAutocomplete,
    },
    props: {
    },
    data() {
        return {
            isEditable: false,
            isDownloadingReport: false,
            comments: [],
            loading: false,
            currentStatus: null,
            availableStatus: [],
            debouncedUpdateWorkOrder: debounce(this.onUpdateWorkOrder, 500),
            debouncedSendUpdate: debounce(this.update, 500),
            validUpdateStatus: [
                labWorkOrderStatus.TODO,
                labWorkOrderStatus.IN_PROGRESS,
                labWorkOrderStatus.SUBMITTED,
            ],
            uploadFileLoading: false,
            newAppendiceFile: null,
            localFiles: [],
            files: [],
            members: [],
            assignedTo: null,
            description: null,
        };
    },
    computed: {
        ...mapGetters([
            'labWorkOrder',
            'hasPermission',
            'hasRole',
            'analysisRequests',
            'lang',
            'siteLang',
            'teamMainLang',
        ]),
        displayedLabMembers() {
            return this.members.map(member => ({
                name: `${member.firstName} ${member.lastName} (${member.email})`,
                id: member.id,
            }));
        },
        title() {
            if (!this.labWorkOrder) {
                return '';
            }

            return this.labWorkOrder.woNumber;
        },
        isApproved() {
            return this.labWorkOrder.status === labWorkOrderStatus.APPROVED;
        },
        isSubmitted() {
            return this.labWorkOrder.status === labWorkOrderStatus.SUBMITTED;
        },
        isSent() {
            return this.labWorkOrder.status === labWorkOrderStatus.SENT;
        },
        isRepOrAdmin() {
            return this.hasPermission('labWorkOrders.recommendation.add') || this.hasRole(roles.ADMINISTRATOR.value);
        },
        hasRepRecommendation() {
            return !!this.labWorkOrder.hasRepRecommendation;
        },
        lastReport() {
            if (!Array.isArray(this.labWorkOrder.reports) || this.labWorkOrder.reports.length === 0) {
                return null;
            }

            // Sort by creation date
            const sorted = sortBy(this.labWorkOrder.reports, report => (new Date(report.createdAt)));
            return last(sorted);
        },
        labWoStatus() {
            const availableStatus = this.availableStatus?.filter(status => status !== this.currentStatus);
            return [this.currentStatus, ...availableStatus]?.map(status => ({ id: status, name: status ? this.$t(`labWorkOrders.labels.${status}`) : '' }));
        },
        labReport() {
            return this.labWorkOrder.summaryReport.reportType.label[this.siteLang || this.teamMainLang];
        },
        lastOpeningComment() {
            const comments = this.comments.filter(item => item.position === 'opening');
            return comments[comments.length - 1];
        },
        lastCommentAndPicture() {
            const comments = this.comments.filter(item => item.position === 'comments');
            return comments[comments.length - 1];
        },
        lastClosingComment() {
            const comments = this.comments.filter(item => item.position === 'closing');
            return comments[comments.length - 1];
        },
        getOptions() {
            return {
                disabled: this.hasPermission('recommendation.add') || this.isSubmitted || this.isApproved || this.isSent,
            };
        },
        infoSectionDisabled() {
            return this.isApproved || this.isSubmitted || this.isSent;
        },
        getActionButtons() {
            return [
                {
                    id: 'btn-summary-edit',
                    label: this.isEditable ? this.$t('forms.btn.view') : this.$t('forms.btn.edit'),
                    action: this.onClickToggle,
                    icon: 'mdi-pencil',
                    color: 'primary',
                    disabled: !this.hasPermission('labWorkOrders.edit'),
                    isHidden: this.isRepOrAdmin,
                },
                {
                    id: 'btn-recommendation',
                    label: this.$t('visitSummary.recommendations'),
                    action: this.addRecommendation,
                    icon: 'mdi-message',
                    color: 'primary',
                    isHidden: !this.isRepOrAdmin,
                },
                {
                    id: 'btn-refreshPdf',
                    label: this.$t('visitSummary.refreshPDF'),
                    action: this.refreshPDF,
                    icon: 'mdi-refresh',
                    color: 'primary',
                    isHidden: !this.isRepOrAdmin,
                    disabled: !this.labWorkOrder.repRecommendation.hasUpdate,
                },
                {
                    id: 'btn-send-to-rep',
                    label: this.$t('visitSummary.sendToRep'),
                    action: this.onClickSendToRep,
                    icon: 'mdi-send',
                    color: 'primary',
                    disabled: !this.isApproved || this.labWorkOrder.isRepRecommendationRequested,
                    isHidden: this.isRepOrAdmin,
                },
                {
                    id: 'btn-visit-send-email',
                    label: this.$t('visitSummary.sendByEmail'),
                    action: this.onClickSendEmail,
                    icon: 'mdi-email',
                    color: 'primary',
                    disabled: !this.isApproved && !this.isSent,
                },
                {
                    id: 'btn-preview-report',
                    label: this.$t(`visitSummary.${this.isApproved || this.isSent ? 'show' : 'preview'}Report`),
                    action: this.downloadReport,
                    icon: 'mdi-download',
                    displayIcon: true,
                    color: 'primary',
                    disabled: !this.hasPermission('labWorkOrders.view') || !this.hasPermission('reports.add'),
                    desktopExtraClass: 'btn-show-report',
                },
            ];
        },
    },
    labWorkOrder: {
        handler() {
            if (!this.labWorkOrder) {
                return;
            }
            this.assignedTo = this.labWorkOrder.assignedTo.id;
            this.description = this.labWorkOrder.description;
        },
        immediate: true,
    },
    created() {
        this.getLabMembers(this.labWorkOrder.client.id);
    },
    async mounted() {
        await this.reloadWorkOrderResults(this.labWorkOrder.id);
        this.getComments();
        this.reloadLabRequest(true);
        this.isLoading = false;
    },
    methods: {
        ...mapActions({
            getLabWorkOrder: 'getLabWorkOrder',
            reloadWorkOrderResults: 'getLabWorkOrderResults',
        }),
        ...mapMutations([
            'updateSummaryReport',
        ]),
        async getLabMembers(clientId) {
            const labRoles = [
                roles.LABORATORY_MANAGER.value,
                roles.LABORATORY_MICROBIOLOGIST.value,
                roles.LABORATORY_CHEMIST.value,
                roles.LABORATORY_TECHNICIAN.value];
            // Just for Admin
            if (this.hasRole(roles.ADMINISTRATOR.value)) {
                labRoles.push(roles.ADMINISTRATOR.value);
            }
            const queryParams = this.hasRole(roles.ADMINISTRATOR.value) ? {} : roles.ADMINISTRATOR.value;
            queryParams.pagination = false;
            queryParams.roles = labRoles;
            const { data } = await this.$rq.getClientMembers(clientId, queryParams);
            this.members = data.members;
        },
        async getComments() {
            const { data } = await this.$rq.getLabWorkOrderComments(this.labWorkOrder.id);
            this.comments = data;
            const appendixComments = data.filter(comment => comment.position === 'appendix');
            this.files = appendixComments.map(comment => comment.files[0] || {});
        },
        onClickToggle() {
            this.isEditable = !this.isEditable;
        },
        async addRecommendation() {
            this.$root.$emit('showModal', {
                title: this.$t('visitSummary.recommendations'),
                component: Vue.component('Recommendations', Recommendations),
                payload: this.hasRepRecommendation ? { populateWith: { ...this.labWorkOrder.repRecommendation } } : {},
                onConfirm: async requestPayload => {
                    try {
                        if (requestPayload) {
                            this.isDownloadingReport = true;
                            await this.$rq.addRecommendationToLabWO(this.labWorkOrder.id, requestPayload);
                            await this.getLabWorkOrder(this.labWorkOrder.id);
                            this.$toasted.global.toast_success({
                                message: this.$t('visitSummary.recommendationAdded'),
                            });
                            this.isDownloadingReport = false;
                        }
                    } catch (error) {
                        this.isDownloadingReport = false;
                    }
                },
            });
        },
        async refreshPDF() {
            try {
                this.isDownloadingReport = true;
                await this.$rq.refreshLabWOReport(this.labWorkOrder.id);
                await this.getLabWorkOrder(this.labWorkOrder.id);
                this.isDownloadingReport = false;
            } catch (error) {
                this.isDownloadingReport = false;
            }
        },
        async onClickSendToRep() {
            this.$root.$emit('showModal', {
                title: this.$t('visitSummary.sendByEmail'),
                payload: {
                    isLab: true,
                    displayEmailObject: true,
                },
                component: Vue.component('SendEmailToUserFormVue', SendEmailToUserFormVue),
                isForm: false,
                onConfirm: async requestPayload => {
                    try {
                        if (requestPayload) {
                            this.isDownloadingReport = true;
                            await this.$rq.sendToRep(this.labWorkOrder.id, requestPayload);
                            await this.getLabWorkOrder(this.labWorkOrder.id);
                            this.isDownloadingReport = false;
                        }
                    } catch (error) {
                        this.isDownloadingReport = false;
                    }
                },
            });
        },
        async reloadLabRequest(isLoaded = false) {
            if (this.labWorkOrder.id) {
                if (!isLoaded) {
                    await this.reloadWorkOrderResults(this.labWorkOrder.id);
                }
                const statusResult = await this.$rq.getLabWorkOrderStatus(this.labWorkOrder.id);
                this.currentStatus = statusResult?.data.currentStatus;
                this.availableStatus = statusResult?.data.availableStatus;
            }
        },
        async onClickSendEmail() {
            this.$root.$emit('showModal', {
                title: this.$t('visitSummary.sendByEmail'),
                payload: { isLab: true },
                component: Vue.component('SendEmailToUserFormVue', SendEmailToUserFormVue),
                isForm: false,
                onConfirm: async requestPayload => {
                    await this.$rq.sendLabWorkOrderReportToUsers(this.labWorkOrder.id, requestPayload);
                    this.$toasted.global.toast_success({
                        message: this.$t('visitSummary.reportSent'),
                    });
                    await this.getLabWorkOrder(this.labWorkOrder.id);
                    this.reloadLabRequest(false);
                },
            });
        },
        async showLastReport() {
            if (!this.lastReport) {
                this.$toasted.global.toast_error({
                    message: this.$t('visitSummary.reportNotFound'),
                });
                return;
            }

            const { file } = this.lastReport;
            const { data } = await this.$rq.downloadFile(file.id);
            this.$utils.saveFileOnDisk(data, file.fileName);
        },
        async downloadReport() {
            try {
                this.isDownloadingReport = true;
                let blob;
                if (this.isApproved || this.isSent) {
                    await this.showLastReport();
                } else {
                    const { data } = await this.$rq.getLabWorkOrderPreliminaryReport(this.labWorkOrder.id);
                    blob = data;
                    const fileName = `${this.$t('visitSummary.previewFileName', {
                        date: (new Date()).getTime(),
                    })}.pdf`;
                    this.$utils.saveFileOnDisk(blob, fileName);
                }
                this.isDownloadingReport = false;
            } catch (error) {
                this.isDownloadingReport = false;
            }
        },
        async updateLabWorkOrderStatus(status) {
            await this.$rq.updateLabWorkOrderStatus(this.labWorkOrder.id, { status });
            await this.reloadLabRequest();
        },
        async onApproveClick() {
            try {
                this.isDownloadingReport = true;
                await this.$rq.submitLabWorkOrder(this.labWorkOrder.id);
                await this.getLabWorkOrder(this.labWorkOrder.id);
                this.isDownloadingReport = false;
            } catch (error) {
                this.isDownloadingReport = false;
            }
        },
        async onChangeLabWoStatus(status) {
            if (this.validUpdateStatus.includes(status)) {
                await this.updateLabWorkOrderStatus(status);
                await this.getLabWorkOrder(this.labWorkOrder.id);
            } else if (status === labWorkOrderStatus.APPROVED) {
                await this.onApproveClick();
                await this.reloadLabRequest();
            }
        },
        onUpdateWorkOrder(name) {
            return this.$rq.updateLabWorkOrderSummaryReport(this.labWorkOrder.id, { name });
        },
        async onDragAndDropChange(file) {
            this.uploadFileLoading = true;
            this.newAppendiceFile = file;
            await this.handleFile([file]);
            await this.getComments();
            this.uploadFileLoading = false;
            this.newAppendiceFile = null;
        },
        async removeFile(fileId) {
            this.newAppendiceFile = null;
            let correspondingComment = {};
            this.comments.every(comment => {
                // get comment based on fileId
                if (comment?.files && comment?.files?.find(file => file.id === fileId)) {
                    correspondingComment = comment;
                    return false;
                }
                return true;
            });
            await this.$rq.deleteFile(fileId); // TODO: do we need this?
            await this.$rq.removeLabWorkOrderComment(this.labWorkOrder.id, correspondingComment.id);
            await this.getComments();
        },
        async handleFile(files) {
            const promises = [];
            files.forEach(file => {
                const formData = new FormData();
                formData.append('file', file);
                const title = file.name.split('.pdf')[0];
                promises.push(this.addFile(formData, title));
            });
            await Promise.all(promises);
        },
        async addFile(formData, title = '') {
            const file = await this.$rq.addFile({ resizePdf: true }, formData);
            const payload = {
                fileId: file.data.id,
                title,
                position: 'appendix',
            };
            await this.$rq.addLabWorkOrderComment(this.labWorkOrder.id, payload);
        },
        async update(attribute, e) {
            await this.$rq.updateLabWorkOrder(this.labWorkOrder.id, { [attribute]: e });
            this.$toasted.global.toast_success({
                message: this.$t('labWorkOrders.updated', { name: this.labWorkOrder.woNumber }),
            });
            this.reloadWorkOrder(this.labWorkOrder.id);
        },
    },
};
</script>
<style scoped>
    .section--title {
      color: #26384B;
      font-family: 'Roboto', sans-serif;
      font-weight: 500;
      font-size: 20px;
      line-height: 23px;
    }
    .contract--number {
      font-size: 30px;
      font-weight: 700;
      color: #26384B;
    }
</style>
